import { ADD_ON_SAVE_CALLBACK, CLEAR_ON_SAVE_CALLBACKS } from '@state/actions/editorActions'

/**
 * Initial state
 */
const initialEditorState = {
    onSaveCallbacks: []
}

/**
 * Reducer
 */
const editorReducer = (state, action) => {
    switch (action.type) {
        case ADD_ON_SAVE_CALLBACK:
            return {
                ...state,
                onSaveCallbacks: {
                    ...state.onSaveCallbacks,
                    [action.payload.id]: action.payload.callback
                }
            }

        case CLEAR_ON_SAVE_CALLBACKS:
            return {
                ...state,
                onSaveCallbacks: [],
            }

        default:
            return state
    }
}

export { editorReducer, initialEditorState }
